import { Component } from '@angular/core';
import { ReportShareComponent } from '../report-share.component';

@Component({
  selector: 'app-styles',
  templateUrl: './styles.component.html'
})
export class StylesComponent extends ReportShareComponent {}
